import { useSearchParams } from 'react-router-dom';
import { Tabs } from '@/components/ui';
import { VoiceAgents } from './VoiceAgents';
import { VoiceTools } from './VoiceTools';
import { VoiceFlows } from './VoiceFlows';
import { AiModelsTab } from './AiModelsTab';

const TABS = [
  { id: 'agents', label: 'סוכנים קוליים' },
  { id: 'flows', label: 'זרימות' },
  { id: 'tools', label: 'כלי API' },
  { id: 'models', label: 'מודלי AI העובדים במערכת' },
];

/**
 * מסך אחד לכל עולם הסוכנים הקוליים של הסופר — סוכנים / זרימות / כלי API
 * בלשוניות. הנתיבים הישנים (/super/voice-tools, /super/voice-flows) מפנים
 * לכאן עם הלשונית המתאימה, כך שקישורים קיימים ממשיכים לעבוד.
 */
export function VoiceCenter() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') ?? 'agents';

  return (
    // שרשרת גובה מלאה: בונה הזרימות (React Flow) בנוי על height:100% —
    // עטיפה בגובה אוטומטי קורסת אותו לגובה אפס ("הזרימה לא נפתחת").
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <div style={{ padding: 'var(--gap) var(--gap) 0', flexShrink: 0 }}>
        <Tabs items={TABS} value={tab} onChange={(id) => setParams(id === 'agents' ? {} : { tab: id }, { replace: true })} />
      </div>
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        {tab === 'agents' && <VoiceAgents />}
        {tab === 'flows' && <VoiceFlows />}
        {tab === 'tools' && <VoiceTools />}
        {tab === 'models' && <AiModelsTab />}
      </div>
    </div>
  );
}
